import audioSources, { AudioSourceDef } from './AudioSources';
import EventEmitter from '../Utils/EventEmitter';

interface AudioPool {
    def: AudioSourceDef;
    pool: HTMLAudioElement[];
    next: number;
}

export default class AudioManager extends EventEmitter {
    private pools: Map<string, AudioPool> = new Map();
    private muted = false;

    constructor() {
        super();
        for (const def of audioSources) {
            const size = def.pool ?? 1;
            const pool: HTMLAudioElement[] = [];
            for (let i = 0; i < size; i++) {
                const a = new Audio();
                a.src = def.path;
                a.preload = 'auto';
                a.volume = def.volume ?? 0.5;
                a.loop = !!def.loop;
                pool.push(a);
            }
            this.pools.set(def.name, { def, pool, next: 0 });
        }

        const keyHandler = (e: KeyboardEvent) => {
            if (e.repeat) return;
            const variants = ['key1', 'key2', 'key3', 'key4'];
            const v = variants[Math.floor(Math.random() * variants.length)];
            this.play(v);
        };
        window.addEventListener('keydown', keyHandler);

        const downHandler = () => this.play('mouseDown');
        const upHandler = () => this.play('mouseUp');
        window.addEventListener('mousedown', downHandler);
        window.addEventListener('mouseup', upHandler);

        const startAmb = () => {
            this.play('office');
            window.removeEventListener('click', startAmb);
        };
        window.addEventListener('click', startAmb, { once: true });
    }

    play(name: string) {
        if (this.muted) return;
        const p = this.pools.get(name);
        if (!p) return;
        const a = p.pool[p.next];
        p.next = (p.next + 1) % p.pool.length;
        try {
            a.currentTime = 0;
            void a.play().catch(() => undefined);
        } catch (e) {}
    }

    setMuted(v: boolean) {
        this.muted = v;
        this.pools.forEach((p) => {
            p.pool.forEach((a) => {
                a.muted = v;
            });
        });
        this.trigger('muted', [v]);
    }

    isMuted() {
        return this.muted;
    }
}
